
function toMonthlyAmount(amount, frequency, format=false){
  let factor = 1;
  switch(frequency){
    case 'Yearly':      factor = 0.08333; break;
    case 'Monthly':     factor = 1; break;
    case 'Fortnightly': factor = 2.167; break;
    case 'Weekly':      factor = 4.333; break;
    case 'Quarterly':   factor = 0.33333; break;
    default:            factor = 1; break;
  }
  let converted = amount * factor;

  if(format)
    converted = currency(converted);

  return converted;
}

function currency(value, decimals=2, force=false){
  if((value === null || value === '' || value === undefined) && !force) return '';
  return '$'+Number(value).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
}

function yearsMonths(months){
  return `${Math.floor(months/12)}y ${Math.round(months%12)}m`;
}

function truth(value, _true="Yes", _false="No"){
  return value ? _true : _false;
}

function round(value, d=0, force=false){
  if((value === null || value === '' || value === undefined) && !force) return '';
  return Number(value).toFixed(d);
}

function percentage(value, d=2, adjust=true, force=false){
  if((value === null || value === '' || value === undefined) && !force) return '';
  value = adjust ? Number(value) * 100 : Number(value);
  return value.toFixed(d) + '%';
}

function prefix(value, prefix, force=false){
  return value || force ? prefix + value : '';
}

function suffix(value, suffix, force=false){
  return value || force ? value + suffix : '';
}

function name(inputName, title=true, middle=false){
  if(!inputName){
    return null;
  }

  if (Array.isArray(inputName)) {
    let nameArray = inputName;
    return (nameArray).map(names => `${name(names)}`).join(", ");
  }

  let parts = [
    title ? inputName.title : null,
    inputName.firstname || inputName.first_name,
    middle ? inputName.middlename || inputName.middle_name : null,
    inputName.lastname || inputName.last_name,
  ];
  parts = parts.filter(p => !!p);

  if (typeof inputName === 'string') {
    return inputName;
  }
  return parts.join(' ');
}

function list(array, seperator=', '){
  return array.join(seperator);
}

function datetime(string, empty=''){

  if(!string) return empty;

  //the new Date object gets localized automatically to users timezone.
  let date = new Date(string);

  let Y = `0000${date.getFullYear()}`.slice(-4);
  let M = `00${date.getMonth()+1}`.slice(-2);
  let D = `00${date.getDate()}`.slice(-2);
  let h = `00${date.getHours()}`.slice(-2);
  let m = `00${date.getMinutes()}`.slice(-2);
  return `${D}/${M}/${Y} ${h}:${m}`;

  return date.toISOString().slice(0, 19).replace(/-/g, "/").replace("T", " ");
}

function dateonly(string, empty=''){

  if(!string) return empty;

  //the new Date object gets localized automatically to users timezone.
  let date = new Date(string);

  let Y = `0000${date.getFullYear()}`.slice(-4);
  let M = `00${date.getMonth()+1}`.slice(-2);
  let D = `00${date.getDate()}`.slice(-2);
  return `${D}/${M}/${Y}`;
}

function float(value, _default=0){
  return Number.parseFloat(value) || _default;
}

/**
 * converts a document id to a url that views the document in the browser
 * @param {string|int} document_id
 * @returns {string} absolute url excluding domain
 */
function viewDocumentUrl(document_id){
  return `/document/${document_id}/view`;
}

/**
 * converts a document id to a url that downloads the document
 * @param {string|int} document_id
 * @returns {string} absolute url excluding domain
 */
function downloadDocumentUrl(document_id){
  return `/document/${document_id}/download`;
}

/**
 * capitalizes the first character of the string, the rest of letters will keep same
 * @param string
 * @returns {string}
 */
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * capitalizes the first character of the string and lower the rest of word
 * @param {string} str 
 * @returns {string} capitalized word
 */
function capitalizeForAllCase(str) {
  return str.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}

/**
 * calculate the age of application in day
 * @param {string} date
 * @return {float} age in days
 */
function ageInDays(date) {
  return (new Date() - new Date(date)) / 86400000;
}

/**
 * get error fields message when save application
 * @param {array} error_fields
 * @returns {string} error message
 */
function getErrorFieldsMessage(error_fields) {
  return `<p style="line-height:2rem;"> Some fields are incorrect.</p>
          <p style="line-height:2rem;">
          Error in fields are:
          <ul style="padding-left: 50px; padding-right: 100px;">
            ${error_fields.map(field => `<li>${field}</li>`).join('')}
          </ul>
          </p>`;
}
/**display the short name of logged user
 *
 * @param string
 * @return {string}
 */
 function shortName(name) {
  if (!name) {
    return null;
  }
  let parts = [
    name.firstname || name.first_name.charAt(0).toUpperCase(),
    name.lastname  || name.last_name.charAt(0).toUpperCase(),
  ];
  parts = parts.filter(p => !!p);
  return parts.join('');
}

/**
 * convert incoming string variable to integer, when it is null, undefined, empty string
 * or non-digital string, return 0.
 * @param {string|null} variable 
 * @returns {integer}
 */
function converToInteger(variable) {
  let result = 0;
  if (variable === null || variable === undefined || variable === '') {
    result = 0;
  } else {
    result = parseInt(variable, 10);
  }
  if (isNaN(result)) {
    return 0
  } else {
    return result;
  }
}

export default {
  toMonthlyAmount,
  currency,
  yearsMonths,
  truth,
  round,
  percentage,
  prefix,
  suffix,
  name,
  list,
  datetime,
  float,
  viewDocumentUrl,
  downloadDocumentUrl,
  dateonly,
  capitalize,
  capitalizeForAllCase,
  ageInDays,
  getErrorFieldsMessage,
  shortName,
  converToInteger,
};
